<template>
  <div class="reportWrapper xml-report">
    <h1 class="xml-report__title">
      {{ title }}
      <sup v-if="showTrademarkSymbol">™</sup>
    </h1>
    <p class="xml-report__section">{{ section }}</p>
    <p class="xml-report__date">Published {{ publishDate }}</p>
    <div v-if="isExecutiveSummary" class="">
      <div class="report-component">
        <p class="announcement-date">
          {{ jsonContent.executive_summary.author }}
        </p>
        <div
          class="margin-top--quarter margin-bottom--quarter background-blue inner-padding--half font-white intro rounded-corners-10"
        >
          <em>{{ jsonContent.executive_summary.call_out.quote_white }}</em>
        </div>
        <template
          v-for="(value, index) in jsonContent.executive_summary.content"
          :key="index"
        >
          <template v-if="index.includes('section_title')">
            <p class="margin-top exec-sum-section-header">{{ value }}</p>
          </template>
          <template v-if="index.includes('body')">
            <p v-html="value"></p>
          </template>
          <template v-if="index.includes('bullet_list')">
            <ul>
              <template v-for="bullet in value" :key="bullet">
                <li>{{ bullet }}</li>
              </template>
            </ul>
          </template>
          <template v-if="index.includes('image')">
            <p v-bind:key="index" class="text-center max-width-1000">
              <img
                :src="images_path + value.attributes.href"
                alt="TR Executive Summary Report Image"
              />
            </p>
          </template>
        </template>
      </div>
    </div>
    <div v-if="isTrends10" class="">
      <div class="report-component">
        <div class="scrollable-image">
          <img
            :src="
              images_path + jsonContent.itr_trends_10.image1.attributes.href
            "
            alt="Trends 10 Image"
          />
        </div>
        <h4 class="margin-top">
          {{ jsonContent.itr_trends_10.summary.section_title }}
        </h4>
        <p v-html="jsonContent.itr_trends_10.summary.body"></p>
      </div>
    </div>
    <div v-if="isAtAGlance || isGlobalAtAGlance" class="">
      <div class="report-component" v-if="jsonContent.core_dashboard">
        <div class="scrollable-image">
          <img
            :src="
              images_path + jsonContent.core_dashboard.image1.attributes.href
            "
            alt="Trends Report Image"
          />
        </div>
        <p class="image-note">{{ jsonContent.core_dashboard.footnote1 }}</p>
        <h5>{{ jsonContent.core_dashboard.phase_key.section_title }}</h5>
        <div class="four-col-wrapper middle-align">
          <template
            v-for="(value, index) in jsonContent.core_dashboard.phase_key"
            :key="index"
          >
            <template v-if="value.phase_icon">
              <div class="col-inner">
                <div class="tr-phase-logo-and-text">
                  <img
                    :src="images_path + value.phase_icon.attributes.href"
                    alt="Insider Report Phase Logo"
                  />
                  <span v-html="value.small_title"></span>
                </div>
              </div>
            </template>
          </template>
        </div>
        <h4
          v-if="jsonContent?.core_dashboard?.summary?.section_title"
          class="margin-top"
        >
          {{ jsonContent.core_dashboard.summary.section_title }}
        </h4>
        <p
          v-if="jsonContent?.core_dashboard?.summary?.body"
          v-html="jsonContent.core_dashboard.summary.body"
        ></p>
      </div>
    </div>
    <div v-if="isLeadingIndicator" class="">
      <div class="report-component">
        <h4>
          {{ jsonContent.leading_indicator.section_title }}
        </h4>
        <p v-html="jsonContent.leading_indicator.body"></p>
        <h4 class="margin-top">
          {{ jsonContent.leading_indicator.section_title2 }}
        </h4>
        <div class="scrollable-image">
          <img
            :src="
              images_path + jsonContent.leading_indicator.image1.attributes.href
            "
            alt="Trends Report Image"
          />
        </div>
        <h4 class="margin-top">
          {{ jsonContent.leading_indicator.section_title3 }}
        </h4>
        <p v-html="jsonContent.leading_indicator.body2"></p>
      </div>
    </div>
    <div v-if="isEconomicOutlook" class="">
      <div class="report-component">
        <div class="two-col-wrapper">
          <div class="col-inner">
            <p v-html="jsonContent.us_economic_outlook.body"></p>
          </div>
          <div class="col-inner">
            <div class="table-responsive">
              <table class="tr-data-table">
                <thead>
                  <tr>
                    <th>{{ jsonContent.table_head.col1 }}</th>
                    <th>{{ jsonContent.table_head.col2 }}</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="row in jsonContent.table" :key="row">
                    <tr>
                      <td style="text-align: center">{{ row.col1 }}</td>
                      <td style="text-align: center">{{ row.col2 }}</td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <h4 class="margin-top">{{ jsonContent.current_data.bg }}</h4>
        <p>
          <img
            :src="images_path + jsonContent.current_data.image1.attributes.href"
            alt="Trends Report Image"
          />
        </p>
      </div>
    </div>
    <div v-if="isIndicatorTypeA" class="">
      <div class="report-component">
        <div class="two-col-wrapper">
          <div
            class="col-inner background-grey-soft inner-padding rounded-corners-10"
          >
            <h4>
              {{ jsonContent.Root.left_col.highlights_block[0].heading.__text }}
            </h4>
            <ul>
              <template
                v-for="(value, index) in jsonContent.Root.left_col
                  .highlights_block[0]"
                :key="index"
              >
                <template v-if="!ignore.includes(index)">
                  <li>{{ value.__text }}</li>
                </template>
              </template>
            </ul>
            <h4>
              {{ jsonContent.Root.left_col.highlights_block[1].heading.__text }}
            </h4>
            <ul class="tr-two-col-table-list">
              <li>
                <div>
                  <strong>
                    {{
                      jsonContent.Root.left_col.highlights_block[1]
                        .table_label_1.__text
                    }}
                  </strong>
                </div>
                <div>
                  {{
                    jsonContent.Root.left_col.highlights_block[1]
                      .table_content_1.__text
                  }}
                </div>
              </li>
              <li>
                <div>
                  <strong>
                    {{
                      jsonContent.Root.left_col.highlights_block[1]
                        .table_label_2.__text
                    }}
                  </strong>
                </div>
                <div>
                  {{
                    jsonContent.Root.left_col.highlights_block[1]
                      .table_content_2.__text
                  }}
                </div>
              </li>
            </ul>

            <h4>
              {{ jsonContent.Root.left_col.highlights_block[2].heading.__text }}
            </h4>
            <ul class="tr-two-col-table-list">
              <li>
                <div>
                  <strong>
                    {{
                      jsonContent.Root.left_col.highlights_block[2]
                        .table_label_1.__text
                    }}
                  </strong>
                </div>
                <div>
                  {{
                    jsonContent.Root.left_col.highlights_block[2]
                      .table_content_1.__text
                  }}
                </div>
              </li>
              <li>
                <div>
                  <strong>
                    {{
                      jsonContent.Root.left_col.highlights_block[2]
                        .table_label_2.__text
                    }}
                  </strong>
                </div>
                <div>
                  {{
                    jsonContent.Root.left_col.highlights_block[2]
                      .table_content_2.__text
                  }}
                </div>
              </li>
              <li>
                <div>
                  <strong>
                    {{
                      jsonContent.Root.left_col.highlights_block[2]
                        .table_label_3.__text
                    }}
                  </strong>
                </div>
                <div>
                  {{
                    jsonContent.Root.left_col.highlights_block[2]
                      .table_content_3.__text
                  }}
                </div>
              </li>
              <li>
                <div>
                  <strong>
                    {{
                      jsonContent.Root.left_col.highlights_block[2]
                        .table_label_4.__text
                    }}
                  </strong>
                </div>
                <div>
                  {{
                    jsonContent.Root.left_col.highlights_block[2]
                      .table_content_4.__text
                  }}
                </div>
              </li>
            </ul>

            <h4>
              {{ jsonContent.Root.left_col.highlights_block[3].heading.__text }}
            </h4>
            <p
              v-html="
                jsonContent.Root.left_col.highlights_block[3].body_copy.__text
              "
            ></p>
          </div>
          <div class="col-inner inner-padding-top">
            <h4>
              {{ jsonContent.Root.right_col.rate_of_change[0].heading.__text }}
            </h4>
            <p>
              <img
                class="chart"
                :src="
                  images_path +
                  jsonContent.Root.right_col.rate_of_change[0].chart_image._href
                "
                alt="Trends Report Image"
              />
            </p>

            <h4>
              {{ jsonContent.Root.right_col.rate_of_change[1].heading.__text }}
            </h4>
            <p>
              <img
                class="chart"
                :src="
                  images_path +
                  jsonContent.Root.right_col.rate_of_change[1].chart_image._href
                "
                alt="Trends Report Image"
              />
            </p>
            <div class="tr-phase-box" v-bind:class="getPhaseMeta">
              <div class="tr-phase-box--left">
                <img
                  :src="images_path + 'images/' + getPhaseMeta + '.png'"
                  alt="Trends Report Phase Logo"
                />
              </div>
              <div class="tr-phase-box--right">
                <h4>
                  {{
                    jsonContent.Root.right_col.rate_of_change[3].title_reverse
                      .__text
                  }}
                </h4>
                <p
                  v-html="
                    jsonContent.Root.right_col.rate_of_change[3].body_copy
                      .__text
                  "
                ></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isIndicatorTypeB" class="">
      <div class="report-component">
        <div class="two-col-wrapper">
          <div
            class="col-inner background-grey-soft inner-padding rounded-corners-10"
          >
            <template
              v-for="block in jsonContent.Root.left_col.highlights_block"
              :key="block"
            >
              <h4 v-if="objectKeyExists(block, 'heading')">
                {{ block.heading.__text }}
              </h4>
              <h4 v-if="objectKeyExists(block, 'forecast')">
                {{ block.forecast.__text }}
              </h4>
              <ul v-if="objectKeyExists(block, 'bullet_1')">
                <template v-for="(value, index) in block" :key="index">
                  <template v-if="!ignore.includes(index)">
                    <li>{{ value.__text }}</li>
                  </template>
                </template>
              </ul>
              <div
                v-if="objectKeyExists(block, 'table')"
                class="table-responsive"
              >
                <table class="tr-data-table darker-borders">
                  <thead>
                    <tr>
                      <th></th>
                      <th>
                        {{ block.table.table_head_row[0].head_col_2.__text }}
                      </th>
                      <th>
                        {{ block.table.table_head_row[0].head_col_3.__text }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <template
                      v-for="(value, index) in block.table.table_head_row"
                      :key="index"
                    >
                      <template v-if="value.col1">
                        <tr>
                          <td>{{ value.col1.__text }}</td>
                          <td style="text-align: center">
                            {{ value.col2.__text }}
                          </td>
                          <td style="text-align: center">
                            {{ value.col3.__text }}
                          </td>
                        </tr>
                      </template>
                    </template>
                  </tbody>
                </table>
              </div>
              <p
                v-if="objectKeyExists(block, 'body_copy')"
                v-html="block.body_copy.__text"
              ></p>
            </template>
          </div>
          <div class="col-inner inner-padding-top">
            <h4>
              {{ jsonContent.Root.right_col.rate_of_change[0].heading.__text }}
            </h4>
            <p>
              <img
                class="chart"
                :src="
                  images_path +
                  jsonContent.Root.right_col.rate_of_change[0].chart_image._href
                "
                alt="Trends Report Image"
              />
            </p>
            <h4>
              {{ jsonContent.Root.right_col.rate_of_change[1].heading.__text }}
            </h4>
            <p>
              <img
                class="chart"
                :src="
                  images_path +
                  jsonContent.Root.right_col.rate_of_change[1].chart_image._href
                "
                alt="Trends Report Image"
              />
            </p>
            <div class="tr-phase-box" v-bind:class="getPhaseMeta">
              <div class="tr-phase-box--left">
                <img
                  :src="images_path + 'images/' + getPhaseMeta + '.png'"
                  alt="Trends Report Phase Logo"
                />
              </div>
              <div class="tr-phase-box--right">
                <h4>
                  {{
                    jsonContent.Root.right_col.rate_of_change[3].title_reverse
                      .__text
                  }}
                </h4>
                <p
                  v-html="
                    jsonContent.Root.right_col.rate_of_change[3].body_copy
                      .__text
                  "
                ></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isIndicatorTypes" class="">
      <div class="report-component">
        <h4>{{ jsonContent.indicator_type.section_title }}</h4>
        <p v-html="jsonContent.indicator_type.body"></p>
        <div class="scrollable-image margin-top--quarter">
          <img
            :src="
              images_path + jsonContent.indicator_type.image1.attributes.href
            "
            alt="TR Indicator Types Report Image"
          />
        </div>
        <h4 class="margin-top">
          {{ jsonContent.indicator_type.section_title2 }}
        </h4>
        <p v-html="jsonContent.indicator_type.body2"></p>
      </div>
    </div>
  </div>
</template>

<script>
  import { computed, ref, onMounted } from 'vue';

  export default {
    name: 'XMLTrTemplate',
    components: {},
    props: {
      report: {
        type: Object,
        required: true,
      },
      content: {
        type: String,
        required: true,
      },
      imagespath: {
        type: String,
        required: false,
      },
      section: {
        type: String,
        required: false,
      },
      publishDate: {
        type: String,
        required: false,
      },
    },

    setup(props) {
      const assetUrl = ref('');

      onMounted(() => {
        assetUrl.value = document
          .getElementById('main-page-wrapper')
          .getAttribute('data-asset-url');
      });

      const asset = (path) => {
        return `${assetUrl.value.replace(/\/$/, '')}${path}`;
      };

      const title = computed(() => {
        return props.report.report_type.name ?? null;
      });

      const createSlugChecker = (slug) => {
        return computed(() => props.report.template.slug === slug);
      };

      const isExecutiveSummary = createSlugChecker('tr-executive-summary');
      const isAtAGlance = createSlugChecker('tr-at-a-glance');
      const isGlobalAtAGlance = createSlugChecker('tr-global-at-a-glance');
      const isEconomicOutlook = createSlugChecker('tr-economic-outlook');
      const isIndicatorTypeA = createSlugChecker('tr-indicator-type-a');
      const isIndicatorTypeB = createSlugChecker('tr-indicator-type-b');
      const isIndicatorTypes = createSlugChecker('tr-indicator-types');
      const isLeadingIndicator = createSlugChecker('tr-leading-indicator');
      const isTrends10 = createSlugChecker('tr-trends-10');

      const jsonContent = computed(() => {
        return JSON.parse(props.content);
      });
      const images_path = computed(() => {
        return props.imagespath;
      });
      const containsKey = (obj, key) => {
        return Object.keys(obj).includes(key);
      };

      const objectKeyExists = (object_path, key) => {
        return containsKey(object_path, key);
      };

      const getPhaseMeta = computed(() => {
        var tempParsePhase = JSON.parse(props.content);
        return tempParsePhase.Root.meta.phase.__text.replace(/_/g, '-');
      });

      const ignore = ['heading'];

      const showTrademarkSymbol = computed(() => {
        return (
          title.value === 'ITR Retail Sales Leading Indicator' ||
          title.value === 'ITR Leading Indicator' ||
          title.value === 'ITR Trends 10'
        );
      });

      return {
        asset,
        objectKeyExists,
        getPhaseMeta,
        title,
        isExecutiveSummary,
        isAtAGlance,
        isGlobalAtAGlance,
        isEconomicOutlook,
        isIndicatorTypeA,
        isIndicatorTypeB,
        isIndicatorTypes,
        isLeadingIndicator,
        isTrends10,
        jsonContent,
        images_path,
        ignore,
        showTrademarkSymbol,
      };
    },
  };
</script>

<style lang="scss" scoped>
  .xml-report {
    font-family: 'Open Sans', sans-serif !important;
    page-break-inside: avoid;

    &__title {
      color: var(--itr-blue);
      font-weight: bold;
      font-size: 40px;
    }
    &__section {
      color: var(--itr-blue);
      font-weight: bold;
      font-size: 26px;
      margin-top: 1rem;
    }
    &__date {
      color: var(--itr-grey-charcoal);
      font-size: 22px;
      font-style: italic;
      margin: 1rem 0 2rem 0;
    }
  }

  .four-col-wrapper {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
  }
  .reportWrapper {
    // margin: 3rem 0;
  }
  .two-col-wrapper {
    display: flex;
    flex-wrap: nowrap !important;
    gap: 4rem;
  }
  .tr-phase-box {
    display: flex;
    flex-direction: row !important;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: nowrap !important;
    gap: 2rem;
    border-radius: 10px;
    padding: 40px;
    img {
      max-width: 120px;
    }
    &--left {
      color: var(--itr-white);
    }
    &--right {
      color: var(--itr-white);
      h4 {
        color: var(--itr-white);
        margin-top: 0;
      }
      p {
        font-size: 18px;
      }
    }
  }
  .tr-phase-box.phase-a {
    background: var(--itr-tr-blue);
  }
  .tr-phase-box.phase-b {
    background: var(--itr-tr-green);
  }
  .tr-phase-box.phase-c {
    background: var(--itr-tr-orange);
  }
  .tr-phase-box.phase-d {
    background: var(--itr-tr-red);
  }
  .margin-top {
    margin-top: 75px;
  }
  .margin-top--quarter {
    margin-top: 40px;
  }
  .margin-bottom--quarter {
    margin-bottom: 40px;
  }
  .background-blue {
    background: #3075a4;
  }
  .inner-padding--half {
    padding: 37.5px 30px;
  }
  .font-white {
    color: #ffffff;
  }
  .rounded-corners-10 {
    border-radius: 10px;
  }
  .intro {
    font-size: 20px;
    line-height: 1.35em;
  }
  .text-center {
    text-align: center;
  }
  .max-width-1000 {
    margin-left: auto;
    margin-right: auto;
    img {
      max-width: 1000px;
    }
  }
  .scrollable-image {
    margin-bottom: 20px;
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    position: relative;

    img {
      flex: 0 0 auto;
      max-width: unset;
      max-height: 75vh;
    }
  }

  .image-note {
    color: #a7a9ab;
    font-size: 15px;
    font-style: italic;
  }
  .col-inner {
    width: calc(50% - 40px);
    @media (min-width: 1600px) {
      width: calc(50% - 60px);
    }
    @media (min-width: 1400px) {
      width: calc(50% - 50px);
    }
    @media (min-width: 1200px) {
      width: calc(50% - 50px);
    }
    @media (min-width: 1000px) {
      width: calc(50% - 40px);
    }
  }
  .tr-phase-logo-and-text {
    display: flex;
    align-items: center;
    img {
      margin-right: 15px;
      max-width: 60px;
    }
    span {
      font-weight: bold;
    }
  }
  .two-col-wrapper {
    display: flex;
    flex-wrap: nowrap;
    padding-right: 1rem;
    gap: 6rem;
    margin-top: 4rem;
  }
  .table-responsive {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }
  table.tr-data-table {
    padding: 0;
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
  }
  table.tr-data-table.darker-borders tr {
    border-bottom: 1px solid var(--itr-grey);
  }
  table.tr-data-table tbody tr td {
    padding: 10px 15px;
  }
  .table-td {
    width: 10%;
  }
  .background-grey-soft {
    background: #f0f1f1;
  }
  .tr-two-col-table-list {
    margin: 0;
    padding: 0;

    li {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      border-top: 1px solid var(--itr-grey);
      padding: 20px 0 !important; // override default unordered lists behavior

      &:last-child {
        border-bottom: 1px solid var(--itr-grey);
      }

      &::before {
        content: ''; // override default unordered lists behavior
        display: none; // override default unordered lists behavior
      }

      > div {
        font-size: 16px;
        width: 100%;
      }
    }
  }
  .inner-padding {
    @media (min-width: 1600px) {
      padding: 75px 65px;
    }
    @media (min-width: 1200px) {
      padding: 65px 50px;
    }
    @media (min-width: 800px) {
      padding: 55px 40px;
    }
    @media (min-width: 480px) {
      padding: 45px 30px;
    }
  }
  h4 {
    font-size: 18px;
    line-height: 1.3em;
    margin-bottom: 12px;
    color: var(--itr-blue);
    font-weight: 800;
    text-transform: uppercase;
  }
  img.chart {
    width: 650px;
    height: 418px;
  }
  .announcement-date {
    text-transform: uppercase;
  }
  .exec-sum-section-header {
    font-size: 18px;
    line-height: 1.3em;
    margin-bottom: 12px;
    color: var(--itr-blue);
    font-weight: 800;
  }
</style>
